import { ProgressBarComponent } from './progress-bar.component';

export default angular
  .module('sfMobile.components.progressBar', [])
  .component('sfProgressBar', ProgressBarComponent).name;
